document.addEventListener('boosterkit-free-gift-added', () => {
    const drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if(drawer){
        fetch('/cart.js?sections=cart-drawer')
            .then((response) => response.json())
            .then((parsedState) => {
                const items = parsedState.items;
                const l = items.length;
                drawer.renderContents(parsedState.items[l - 1]);
            })
    }
});